/*
<summary>
   This enum defines the tool_master.mounting_status values (whether a Main Unit/Applicator is
   currently mounted).
   Developer: Aashish Singh, Created Date: 25-Aug-2026
</summary>
*/
enum MountingStatusEnum {
  Mounted = 0,
  NotMounted = 1,
}

export default MountingStatusEnum;
